module.exports = __webpack_public_path__ + "img/not-authorized-dark.fbc566b0.svg";